import React from "react"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"

import {
  addComboToOrder,
  editComboOrder,
  foodSidebarScrollToButtom
} from "@redux"
import { Button } from "components"
import { createComboData } from "utils"

const ComboModalDoneButton = props => {
  const {
    combo,
    editMode,
    orderComboIndex,
    setOpenModal,
    selectedComboItems
  } = props

  const validate = () => {
    for (let i = 0; i < combo.comboSets.length; i++) {
      const comboSet = combo.comboSets[i]

      if (comboSet.isFixed) continue

      const thisComboSetSelectedComboItems =
        selectedComboItems.filter(selectedComboItem =>
          selectedComboItem.comboSetId === comboSet._id
        )

      const totalSelectedComboItems =
        thisComboSetSelectedComboItems.reduce((t, selectedComboItem) =>
          t += selectedComboItem.quantity
          , 0
        )

      if (totalSelectedComboItems === comboSet.maxQty) continue

      toast.error(`لطفا ${comboSet.maxQty} آیتم از ${comboSet.name} را انتخاب کنید`, { autoClose: false })

      return false
    }

    return true
  }

  const handleDone = () => {
    if (!validate()) return

    const newCombo =
      createComboData(combo, selectedComboItems)

    if (editMode) {
      dispatch(
        editComboOrder(orderComboIndex, newCombo)
      )
    } else {
      dispatch(
        addComboToOrder(newCombo)
      )

      dispatch(
        foodSidebarScrollToButtom()
      )
    }

    setOpenModal(false)
  }

  const dispatch = useDispatch()

  return (
    <Button
      color="success"
      onClick={handleDone}
    >
      افزودن
    </Button>
  )
}

export default ComboModalDoneButton